export const SSO_URL = 'https://doladuj.plus.pl/api/plksso/start'
